import React from 'react';
import { getRelevantChains } from '@sc1/common/utils/constants';
import { ChainTab } from './ChainTab';
import { Box } from '../../core';

export const ChainTabs = (props: any): JSX.Element => {
  const allChains = getRelevantChains();
  return (
    <Box {...props}>
      {allChains.map((chain) => (
        <ChainTab key={chain} chain={chain} />
      ))}
    </Box>
  );
};
